import React from 'react';
import { Route } from 'react-router-dom';

const NavRoute = ({ route, ...props }) => <Route path={route.path} {...props} />;

export default NavRoute;
